import { motion } from 'framer-motion';
import { useEffect } from 'react';

const variants = {
  initial: {
    top: 1000,
    opacity: 0
  },
  animate: {
    opacity: 1,
    top: '1.5rem',
    transition: {
      duration: 0.5,
      ease: [0.87, 0, 0.13, 1],
    },
  },
};

function ContentContainer(props) {
  useEffect(() => {
    document.title = (props.title + " | Squam's Website") || "";
  }, [props.title]);
  return (
    <div className="container text-seafoam font-cousine text-left mx-auto py-5 px-5 inset-0 flex items-center justify-center overflow-hidden">
      <motion.div
        initial="initial"
        animate="animate"
        variants={variants}
        className="relative z-50 w-full bg-black"
      >
        {props.children}
      </motion.div>
    </div>
  );
}

export default ContentContainer;
